// extracted by mini-css-extract-plugin
module.exports = {"bookmarkButton":"BookmarkButton_bookmarkButton__16y5Q","bookmarkButtonActive":"BookmarkButton_bookmarkButtonActive__3GmvW"};